import React from "react";

// Modules
import EtAdminAnalyticsOverview from "@/utils/admin/EtAdminAnalyticsOverview";
import EtAdminTrafficAnalytics from "@/utils/admin/EtAdminTrafficAnalytics";
import EtAdminFunnels from "@/utils/admin/EtAdminFunnels";
import EtAdminEvents from "@/utils/admin/EtAdminEvents";
import EtAdminSessions from "@/utils/admin/EtAdminSessions";
import EtAdminGrowthSparks from "@/utils/admin/EtAdminGrowthSparks";
import EtAdminLeadFlow from "@/utils/admin/EtAdminLeadFlow";
import EtAdminHeatmaps from "@/utils/admin/EtAdminHeatmaps";
import EtAdminUTMTracking from "@/utils/admin/EtAdminUTMTracking";
import EtAdminPixelStatus from "@/utils/admin/EtAdminPixelStatus";
import EtAdminSiteHealth from "@/utils/admin/EtAdminSiteHealth";

const EtWebAdminContentArea = ({ activeMenuItem }) => {

  // First Created - 29 Nov 2025
  // Author - Atul Pandey 

  const renderModule = () => {
    switch (activeMenuItem) {
      case "analyticsOverview":
        return <EtAdminAnalyticsOverview />;
      case "trafficAnalytics":
        return <EtAdminTrafficAnalytics />;
      case "funnels":
        return <EtAdminFunnels />;
      case "events":
        return <EtAdminEvents />;
      case "sessions":
        return <EtAdminSessions />;
      case "growthSparks":
        return <EtAdminGrowthSparks />;
      case "leads":
        return <EtAdminLeadFlow />;
      case "heatmaps":
        return <EtAdminHeatmaps />;
      case "utmTracking":
        return <EtAdminUTMTracking />;
      case "pixels":
        return <EtAdminPixelStatus />;
      case "siteHealth":
        return <EtAdminSiteHealth />;
      default:
        return <EtAdminAnalyticsOverview />;
    }
  };

  return (
    <div className="w-4/5 bg-white p-4 ml-4 rounded shadow-lg h-[85vh] overflow-y-auto">
      {renderModule()}
    </div>
  );
};

export default EtWebAdminContentArea;